<div class="dialog-header">
  <mat-icon class="dialog-back" (click)="$event.stopPropagation(); tryClose('back')">chevron_left</mat-icon>
  <span class="dialog-title">{{ isEdit ? 'Videoblock bearbeiten' : 'Videoblock hinzufügen' }}</span>
  <mat-icon class="dialog-close" (click)="$event.stopPropagation(); tryClose(null)">close</mat-icon>
</div>
<div class="dialog-body">
  <label class="field-label">Titel des Videos (optional)</label>
  <input class="field-input" [formControl]="$any(form.controls['title'])">

  <label class="field-label">Beschreibungstext (optional)</label>
  <textarea class="field-input" [formControl]="$any(form.controls['body_text'])" rows="4"></textarea>

  <label class="field-label">Videodatei{{ isEdit ? '' : '*' }}</label>

  @if (videoPlaybackUrl && !showVideoReplace) {
    <div class="video-player-container">
      <video [src]="videoPlaybackUrl" controls class="video-player"></video>
      <div class="video-actions">
        <button type="button" class="video-action-btn" (click)="downloadVideo()">
          <mat-icon>download</mat-icon>
          <span>Herunterladen</span>
        </button>
        <button type="button" class="video-action-btn" (click)="showVideoReplace = true">
          <mat-icon>swap_horiz</mat-icon>
          <span>Video ersetzen</span>
        </button>
      </div>
    </div>
  }

  @if (!videoPlaybackUrl || showVideoReplace) {
    <div class="file-upload-row" (click)="videoInput.click()">
      <mat-icon class="upload-icon">cloud_upload</mat-icon>
      <span class="upload-label">Datei Upload{{ isEdit ? '' : '*' }}</span>
      <span class="upload-hint">(Max. 100 MB, Formate: .mov, mp4)</span>
      <input #videoInput type="file" accept=".mp4,.mov" (change)="onVideoSelected($event)">
    </div>
    @if (videoFileName && showVideoReplace) {
      <p class="file-name">{{ videoFileName }}</p>
    }
  }
  @if (videoError) {
    <p class="file-error">{{ videoError }}</p>
  }

  <label class="field-label">Vorschaubild (optional)</label>
  <div class="file-upload-row" (click)="previewInput.click()">
    <mat-icon class="upload-icon">cloud_upload</mat-icon>
    <span class="upload-label">Datei Upload</span>
    <span class="upload-hint">(Max. 5 MB, Formate: jpg, png)</span>
    <input #previewInput type="file" accept=".jpg,.jpeg,.png" (change)="onPreviewSelected($event)">
  </div>
  @if (previewError) {
    <p class="file-error">{{ previewError }}</p>
  }

  @if (previewUrl) {
    <div class="image-preview">
      <img [src]="previewUrl" alt="Vorschaubild" style="max-width: 100%; border-radius: 8px;">
    </div>
  }
</div>
<div class="dialog-footer">
  <button class="dialog-save-btn" (click)="save()" [disabled]="!isValid">Speichern</button>
</div>
